module.exports = __webpack_public_path__ + "static/media/MarketplaceLogo.7df477e2.png";